import * as React from 'react'
import { FC, useMemo } from 'react'
import { ErrorSummary } from './typings'
import { bulkActionErrors } from '../../constants'
import {
  BulkActionCircularProgress,
  BulkActionErrorDescription,
  BulkActionErrorSummary,
} from '../../BulkActionErrors'

type Props = {
  loading: boolean
  errorSummary: ErrorSummary
}

export const RowErrors: FC<Props> = (props) => {
  const {
    errorSummary: { count, hasUnmetReqs, hasAlreadyClosed },
    loading,
  } = props

  const description = useMemo(() => {
    const noun = count === 1 ? 'record' : 'records'
    return `${count} ${noun} found that cannot be updated.`
  }, [count])

  const display = useMemo(
    () => !loading && count > 0 && (hasUnmetReqs || hasAlreadyClosed),
    [count, hasAlreadyClosed, hasUnmetReqs, loading],
  )

  return (
    <>
      <BulkActionCircularProgress loading={loading} mt={3} mx="auto" />
      {display ? (
        <>
          <BulkActionErrorSummary description={description} />
          {hasUnmetReqs && (
            <BulkActionErrorDescription
              detail={bulkActionErrors.updateStatus.requirements}
            />
          )}
          {hasAlreadyClosed && (
            <BulkActionErrorDescription
              detail={bulkActionErrors.updateStatus.closed}
            />
          )}
        </>
      ) : null}
    </>
  )
}
RowErrors.displayName = 'RowErrors'
